// 基准大小
export let baseSize = 14;

// 设置 rem 函数
function setRem() {
    // 当前页面宽度相对于 1920 宽的缩放比例，可根据自己需要修改。
    const scale = window.innerWidth / 1440;
    // 设置页面根节点字体大小, 浏览器字体大小最小为12 ↓ 采用下面
    // let fontSize = baseSize * Math.min(scale, 2) > 12 ? baseSize * Math.min(scale, 2) : 12;
    // electron 可以更小 ↓ (个人项目需要)
    const fontSize = baseSize * Math.min(scale, 2);
    // document.documentElement.style.fontSize = fontSize + 'px';
    if(window.innerWidth > 1680) {
        baseSize = 16
    } else if(window.innerWidth <= 1680 && window.innerWidth >= 1370) {
        baseSize = 14
    } else {
        baseSize = 12
    }
    document.documentElement.style.fontSize = baseSize + 'px';
}
// 初始化
setRem();
// 改变窗口大小时重新设置 rem,这里最好加上节流
window.onresize = function () {
    console.log('resize', window.innerWidth);
    setRem();
};
export const getRealPx = (size: number | string) => {
    const scale = window.innerWidth / 1440;
    return +size * scale;
};
